module.exports = __webpack_public_path__ + "img/card_ip_stipulation5.002f303b.svg";